import { extendTheme } from '@chakra-ui/react';
import themeColors from './theme/themeColors.json';

// Define the config for color mode
const config = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

// Extend the theme with custom colors, fonts, etc.
const theme = extendTheme({
  semanticTokens: {
    colors: {
      // UI Backgrounds
      'bg.surface': {
        _light: themeColors.background.default, // e.g., '#F5F5F5'
        _dark: 'gray.800', // A common dark mode background
      },
      'bg.element': {
        _light: themeColors.background.paper, // e.g., '#FFFFFF' for cards, inputs
        _dark: 'gray.700',
      },
      // Text Colors
      'text.primary': {
        _light: themeColors.text.primary, // e.g., 'rgba(0, 0, 0, 0.87)'
        _dark: 'whiteAlpha.900',
      },
      'text.secondary': {
        _light: themeColors.text.secondary, // e.g., 'rgba(0, 0, 0, 0.6)'
        _dark: 'whiteAlpha.700',
      },
      // Brand/Primary Action Colors
      'brand.primary': {
        _light: 'brand.500', // Using your existing brand color for light mode
        _dark: 'brand.300', // A lighter shade for dark mode
      },
      'button.primary.bg': {
        _light: 'brand.500',
        _dark: 'brand.300',
      },
      'button.primary.text': {
        _light: themeColors.primary.contrastText, // e.g., '#FFFFFF'
        _dark: themeColors.text.primary, // Dark text on lighter brand.300
      },
      // Border Colors
      'border.primary': {
        _light: 'gray.200',
        _dark: 'gray.600',
      },
      // Error Message Colors
      'error.bg': {
        _light: themeColors.error.light || 'red.100', // Fallback if not in themeColors.json
        _dark: themeColors.error.dark || 'red.800',  // Fallback
      },
      'error.textOnBg': {
        _light: themeColors.error.main || 'red.700', // Fallback
        _dark: themeColors.error.contrastText || 'red.100', // Fallback
      },
      // Input Field Colors
      'input.bg': {
        _light: themeColors.background.paper || 'white',
        _dark: 'gray.700',
      },
      'input.border': {
        _light: 'gray.200',
        _dark: 'gray.600',
      },
      'input.text': {
        _light: themeColors.text.primary || 'gray.900',
        _dark: 'whiteAlpha.900',
      },
      'input.placeholder': {
        _light: themeColors.text.disabled || 'gray.500', // Using disabled as a proxy for placeholder
        _dark: 'whiteAlpha.400',
      },
      // Link Colors
      'link.primary': {
        _light: themeColors.primary.main, // e.g. blue.500
        _dark: themeColors.primary.light, // e.g. blue.300
      }
    },
  },
  config,
  colors: {
    brand: {
      50: '#e6f7ff',
      100: '#b3e0ff',
      200: '#80caff',
      300: '#4db3ff',
      400: '#1a9dff',
      500: '#0080ff',
      600: '#0066cc',
      700: '#004d99',
      800: '#003366',
      900: '#001a33',
    },
  },
  fonts: {
    heading: "'Inter', sans-serif",
    body: "'Inter', sans-serif",
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'semibold',
        borderRadius: 'md',
      },
    },
  },
});

export default theme;
